module.exports = {
	"apertureWidth": "孔径宽度",
	"apertureLength": "孔径长度",
	"apertureGap1": "孔隙 1",
	"apertureGap2": "孔隙 2",
	"ballDiameter": "焊球直径",
	"bodyOffset": "主体偏移",
	"bodyLength": "主体长度",
	"bodyDiameter": "主体直径",
	"bodyHeight": "主体高度",
	"bodyColor": "主体颜色",
	"componentFamily": "元件族",
	"colPitch": "列间距",
	"chipArrayNote": "* L1 和 b1 是可选的。",
	"crystalNote": "* 从(D、D2、L)中选择可选的尺寸。不同的组合可能会生成不同的示意图焊盘大小。",	
	"densityLevel": "密度级别",	
	"femaleStandoffNote": "* 安装孔焊盘是可选的，为左图中显示的尺寸输入值可生成安装孔焊盘。孔直径(b)用于生成安装孔，以及用于没有加工内螺纹的垫片机械模型。",
	"footprintOrigin": "示意图原点",
	"hPinPitch": "水平引脚间距",
	"hTerminalGap": "水平端子间隙",
	"hTerminalTailLength": "水平端子尾部长度",
	"innerThreadDepth": "内螺纹深度",
	"innerThreadSize": "内螺纹尺寸",
	"innerThreadDesignation": "内螺纹规格",
	"leadDiameter": "引线直径",
	"leadSpan": "引线跨距",
	"leadSpan1": "引线跨距 1",
	"leadSpan2": "引线跨距 2",
	"leadShape": "引线形状",
	"largerTerminalLength": "较大端子长度",
	"largerTerminalWidth": "较大端子宽度",
	"maleFemaleStandoffNote": "* 安装孔焊盘是可选的，为左图中显示的尺寸输入值可生成安装孔焊盘。孔直径(b)用于生成安装孔。",
	"mapSilkscreen": "将丝印层映射到主体",
	"optionalDimensionNote": "* 从(D、D2、L)中选择可选的尺寸。不同的组合可能会生成不同的示意图焊盘大小。",
	"oddTerminalLength": "奇数端子长度",
	"oddTerminalWidth": "奇数端子宽度",
	"optionalDimension": "可选尺寸",	
	"partialThread": "半螺纹",	
	"pasteCoverage": "焊膏覆盖范围",
	"producibilityLevel": "可生产性级别",
	"pinPitch": "引脚间距",
	"padToHoleRatio": "焊盘与孔的比例",
	"padRoundness": "焊盘圆度",
	"pinNumbering": "引脚编号",
	"postLength": "立柱长度",
	"postThreadSize": "立柱螺纹尺寸",
	"postThreadDesignation": "立柱螺纹规格",
	"rowPitch": "行间距",
	"tabWidth": "夹持凸台宽度",
	"tabLength": "夹持凸台长度",
	"terminalThickness": "端子厚度",
	"terminalWidth": "端子宽度",
	"terminalLength": "端子长度",
	"terminalGap": "端子间隙",
	"terminalCCGap": "端子中心到中心间隙",
	"terminalCCGap1": "端子中心到中心间隙 1",
	"terminalCCGap2": "端子中心到中心间隙 2",
	"terminalTailLength": "端子尾部长度",
	"terminalPostLength": "端子立柱长度",
	"terminalType": "端子类型",	
	"threadDepth": "螺纹深度",
	"threadSize": "螺纹尺寸",
	"threadDesignation": "螺纹规格",	
	"threaded": "带螺纹",
	"truncateMiddlePin": "截断中间引脚",		
	"vPinPitch": "垂直引脚间距",
	"vTerminalGap": "垂直端子间隙",
	"vTerminalTailLength": "垂直端子尾部长度",
	"#Rows": "行数",
	"#Cols": "列数",
	"#Pins": "引脚数",
	"#DPins": "引脚数(D 侧)",
	"#EPins": "引脚数(E 侧)",
	"padShape": "焊盘形状",
	"RESISTOR": "电阻器",
	"NONPOLARIZED_CAPACITOR": "电容器 - 非极化",
	"POLARIZED_CAPACITOR": "极化电容器",
	"DIODE": "二极管",
	"FUSE": "熔断器",
	"INDUCTOR": "电感器",
	"POLARIZED_INDUCTOR": "极化电感器",
	"NONPOLARIZED_INDUCTOR": "电感器 - 非极化",
	"LRCCW": "从左下角按逆时针顺序",
	"LRCW": "从左上角按顺时针顺序",
	"ZZBT": "从左下角按之字形顺序",
	"PIN_ONE": "引脚 1",
	"CENTER_PADS": "焊盘中心",
	"female": "内螺纹",
	"male": "外螺纹",
	"maleFemale": "内外螺纹",
	"ROUND": "圆形",
	"HEX": "六角形",
	"SQUARE": "方形",
	"Round": "圆形",
	"Square": "方形",
	"RoundedSquare": "圆角方形",
	"Rectangle": "矩形",
	"Black": "黑色",
	"Green": "绿色",
	"Blue": "蓝色",
	"Yellow": "黄色",
	"Amber": "琥珀色",
	"Brown": "褐色",
	"Cyan": "青色",
	"Maroon": "栗色",
	"Grey": "灰色",
	"Silver": "银色",
	"Purple": "紫色",
	"Red": "红色",
	"White": "白色",
	"Most (A)": "最多(A)",
	"Nominal (B)": "额定(B)",
	"Least (C)": "最少(C)",
	"Most (M)": "最多(M)",
	"Nominal (N)": "额定(N)",
	"Least (L)": "最少(L)",
	"IC": "集成电路(IC)",
	"PRECISION_INDUCTOR": "精密电感器",
	"LED": "LED",
	"THERMISTOR": "热敏电阻",
	"POLARIZED_DIODE": "二极管",
	"VARISTOR": "压敏电阻",
	"FERRITE_BEAD": "磁珠",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "芯片",
	"SOD": "SOD",
	"MOLDED_BODY": "模制体",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "晶振",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "芯片阵列，两侧平面/凹面",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "芯片阵列，四侧平面/凹面",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "芯片阵列，两侧凸面",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "振荡器拐角凹面",
	"OSCILLATOR_J_LEAD": "振荡器 J 形引线",
	"OSCILLATOR_L_BEND": "振荡器 L 形折弯",
	"SOJ": "SOJ",
	"AXIAL": "轴向",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "直线型引脚头(外螺纹)",
	"PIN_HEADER_RA": "直角型引脚头(外螺纹)",
	"RECEPTACLE_HEADER_STRAIGHT": "直线型插座头(内螺纹)",
	"RECEPTACLE_HEADER_RA": "直角型插座头(内螺纹)",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "径向通用(圆形)",
	"RADIAL_LED": "径向 LED (圆形)",
	"CRYSTAL_HC49": "晶振(HC49)",
	"FEMALE_STANDOFF": "内螺纹紧密距/垫片",
	"MALE_FEMALE_STANDOFF": "内外螺纹紧密距",
	"SNAP_LOCK": "弹簧锁",
	"Optional_D": "D (引线跨距)",
	"Optional_D2": "D2 (端子间隙)",
	"Optional_L": "L (端子长度)",
	"CONCAVE": "凹面",
	"FLAT": "平面",
	"Oblong": "椭圆形",
	"Collapsing_Ball": "可塌落焊球",
	"Non_Collapsing_Ball": "非塌落焊球",
	"mountingHolePad": "安装孔焊盘",
	"withVias": "带有过孔",
	"viasCount": "过孔计数",
	"viaDiameter": "过孔直径",
	"viaOffset": "过孔自孔中心的偏移",
	"viaThermalRelief": "过孔热风焊盘",
	"radialLedNote": "* c 不适用于圆角引线形状。",
	"lockHeight": "锁定高度",
	"overrideLockDiameter": "替代锁定直径",
	"lockDiameter": "锁定直径",
	"overridePitch": "替代引脚间距",
	"bodyWidth": "主体宽度",
	"padWidth": "焊盘宽度",
	"plated": "电镀",
	"ViaOffset": "过孔自孔中心的偏移",
	"holeDiameter": "孔直径",
	"snapLockNote1": "* 锁定直径(E1)会基于主体直径(E)和孔直径(b)自动计算。但是，您可以通过替代锁定直径来提供自定义值。",
	"snapLockNote2": "* 孔直径(b)不应等于主体直径(E)和锁定直径(E1)",
	"leadWidth": "引线宽度",
	"leadThickness": "引线厚度",
	"boardThickness": "板厚",
	"error1": "未实现。",
	"fabricationTolerance": "制造公差", 
	"placementTolerance": "放置公差",
	"CAPACITOR": "电容器 - 非极化",
	"CAPACITOR_NONPOLARIZED": "电容器 - 非极化",
	"CAPACITOR_NON_POLARIZED": "电容器 - 非极化",
	"FILTER": "过滤器", 
	"TRANSISTOR": "晶体管",
	"ecapNote": "* 从(D、D2、L)中选择可选的尺寸。不同的组合可能会生成不同的示意图焊盘大小。",
	"maximum": "最大", 
	"nominal": "额定", 
	"minimum": "最小",
	"bodyShape": "主体形状",
	"customSolderPaste": "自定义焊膏",
	"thermalPad": "热焊盘",
	"thermalPadLength": "热焊盘长度",
	"thermalPadWidth": "热焊盘宽度",
	"RoundedRectangle": "圆角矩形",
	"extendedEdgeLength": "延伸边长",
	"Generator": " 生成器",
	"axialNote": "* 引脚间距是根据主体尺寸、端子和可生产性级别自动计算的，以使示意图符合 IPC 标准。但是，您可以通过替代引脚间距来提供自定义值，以创建不符合 IPC 标准的示意图。",
	"baseHeight": "基准高度",
	"CHIP_LED": "芯片 LED",
	"updatePreview": "更新预览",
	"Custom": "自定义",
	"ledColorNote": "* 在“六角形”中输入值以指定自定义主体颜色。",
	"customBodyColor": "自定义主体颜色",							
	"lensShape": "镜头形状",
	"domeDiameter": "圆顶直径",
	"RECT_FLAT_TOP": "平顶矩形",
	"RECT_DOMED_TOP": "圆顶矩形",
	'customFootprint': '自定义示意图',
	'customPadLength': '自定义焊盘长度',
	'customPadWidth': '自定义焊盘宽度',
	'customPadGap': '自定义焊盘间隙',
	'customOddPadWidth': '自定义奇数焊盘宽度',
	'customOddPadLength': '自定义奇数焊盘长度',
	'customPadDiameter': '自定义焊盘直径',
	'customPadSpan1': '自定义焊盘跨距 1',
	'customPadSpan2' : '自定义焊盘跨度 2',
	'customPadPitch' : '自定义焊盘间距',
	'pinPitch1' : '引脚间距 1',
	'customPadGap1': '自定义焊盘间隙 1',
	'Optional_g': 'g (自定义焊盘间隙)',
	'Optional_p': 'p (自定义焊盘间距)',

	// JS Widgets
	"New_Library": "新建库",
	"Components": "元件",
	"Component": "元件",
	"Symbols": "符号",
	"Symbol": "符号",
	"Footprints": "示意图",
	"Footprint": "示意图",
	"Packages": "封装",
	"Package": "封装",
	"No": "否",
	"Name": "名称",
	"Pins": "引脚",
	"Pads": "焊盘",
	"Description": "说明",
	"Variants": "变体",
	"Type": "类型",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io URN",
	"Library_io_Version": "Library.io 版本",
	"Link": "链接",
	"Rename": '重命名',
	"Edit_Description": '编辑说明',
	"Duplicate": '复制', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": '创建新三维模型',
	"Attach_Copy_Existing_3D_Model": '附着现有三维模型的副本',
	"Edit": '编辑',
	"Delete": '删除',
	"Remove_From": '从中删除',
	"Update_To_Latest": '更新到最新版本',
	"Create_New_Symbol": '创建新符号',
	"Create_New_Footprint": '创建新示意图',
	"Create_New_Component": '创建新元件',
	"Create_New_Package": '创建新封装',
	"Delete_Package_Children_Warning": "这也将删除此示意图使用的封装。",
	"No_Search_Results": "无搜索结果",
	"No_Library_Loaded": "库未加载",
	"Library_Stored_Fusion_Hub": "此库存储在 your Fusion Hub 中。",
	"Library_Linked_Managed_Library": "此库链接到 Library.io 托管库。",
	"Library_Local_Changes": "此库具有尚未推送到 Library.io 的更改。为此，请转至“管理”工具栏。",
	"Library_Remote_Changes": "此库具有可从 Library.io 提取的新更新。为此，请转至“管理”工具栏。",
	"View_on_Library_io": "在 Library.io 上查看",
	"Used_In": "用于",
	"No_Selection": "未选择",

	"No_Footprints": "无示意图",
	"No_Symbols": "无符号",
	"No_Components": "无元件",
	"No_Packages": "无封装",

	"Package_Loading_Message": "正在保存和上传封装，请稍候。",
	"Attributes": "属性",
	"View_Attributes": "查看属性",
	"Edit_Attributes": "查看属性",
	"Edit_Description": "编辑说明",
	
	"Use_Placeholder": "使用占位符",
	"Placeholder_Message": "当没有三维模型与示意图关联时，使用占位符形状。",

	"Hub": "Hub",
	"New_Symbol": '新建符号',
	"New_Footprint": '新建示意图',
	"New_Component": '新建元件',
	"New_Package": '新建封装',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Library.io 封装更新可用。请单击鼠标右键，然后选择“更新”。",
	"Package_Behind_Fusion": "Fusion 封装更新可用。请单击鼠标右键，然后选择“更新”。",
	"Package_Behind_Both": "封装更新可用。请单击鼠标右键，然后选择“更新”。",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "必须先更新库，然后才能提取资产更改。若要更新库，请使用“管理”工具栏。",
}